import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { PollOptionResponse } from '../../../../../../api/types/settings/settings-all';
import { updateOptionOperation } from '../operations/update-option-operation';

interface EditOptionDialogProps {
  pollId: number;
  questionId: number;
  option: PollOptionResponse;
  closeDialog: () => void;
}

export const EditOptionDialog: React.FC<EditOptionDialogProps> = ({
  pollId,
  questionId,
  option,
  closeDialog,
}) => {
  const [optionText, setOptionText] = useState(option.optionText);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    await updateOptionOperation(
      pollId,
      questionId,
      option.id,
      optionText,
      setLoading,
      closeDialog,
    );
  };

  const isValid = optionText.trim().length >= 1;

  return (
    <div style={{ direction: 'rtl' }}>
      <div style={{ marginBottom: '16px' }}>
        <label
          style={{
            display: 'block',
            marginBottom: '8px',
            fontWeight: 500,
            color: '#374151',
          }}
        >
          טקסט התשובה
        </label>
        <InputText
          value={optionText}
          onChange={(e) => setOptionText(e.target.value)}
          placeholder="הזן את טקסט התשובה"
          style={{ width: '100%' }}
          autoFocus
        />
      </div>

      <div
        style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'flex-end',
          marginTop: '24px',
          paddingTop: '16px',
          borderTop: '1px solid #e5e7eb',
        }}
      >
        <Button
          label="ביטול"
          icon="pi pi-times"
          className="p-button-outlined p-button-secondary"
          onClick={closeDialog}
          disabled={loading}
        />
        <Button
          label="עדכון תשובה"
          icon="pi pi-check"
          onClick={handleSubmit}
          loading={loading}
          disabled={!isValid}
        />
      </div>
    </div>
  );
};
